import { Component, OnInit } from '@angular/core';
import { UserService, GeneralService } from '../../../services/_index';
import { MatDialog, MatDialogRef } from '@angular/material';
import { UserModel,ConfirmPasswordRequest,ConfirmPasswordModel } from '../../../_models/_index';
import { Router } from '@angular/router';
import { LoginErrorEnum } from '../../../_enums/login-error.enum';

@Component({
  selector: 'app-approve-login',
  templateUrl: './approve-login.component.html',
  styleUrls: ['./approve-login.component.css']
})
export class ApproveLoginComponent implements OnInit {

   
    user: UserModel;
    confirmPasswordRequest: ConfirmPasswordRequest;

    constructor(private router: Router,
        private generalService: GeneralService,
        private userService: UserService,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<ApproveLoginComponent>) {
        this.confirmPasswordRequest = new ConfirmPasswordRequest();
        
    }

  ngOnInit() {
  }

  login() {
      this.confirmPasswordRequest.userID = this.user.id;
      this.userService.confirmPassword(this.confirmPasswordRequest).then(result => {
          let message;
          if (result) {
              if (result.hasError) {
                  switch (+result.errorID) {
                      case LoginErrorEnum.NotValid:
                          message = "משתמש לא תקין-פנה למנהל המערכת";
                          break;
                      case LoginErrorEnum.PasswordExpired:
                          message = "תוקף סיסמא פג";
                          break;
                      case LoginErrorEnum.PasswordNotValid:
                          message = "סיסמא לא נכונה";
                          break;
                      default:
                          message = "תקלה לא מזוהה";
                          break;
                  }
                  this.confirmPasswordRequest.confirmPassword = '';
                  this.generalService.showErrorDialog(message);
              }
              else
              {
                  this.user = result.user;
                  this.dialogRef.close(this.user);
              }
          }
             
      });

     
  }

  sendCodeAgain() {
      this.userService.sendCodeOnLogin(this.user).then(result => {
          if (result) {
              this.user = result;
              this.generalService.showInformationDialog("קוד נשלח שנית");
          }
          else {
              this.generalService.showErrorDialog('תקלה בשליחת קוד ');
              
          }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/approve-login/approve-login.component.ts